import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
export function SocialProof() {
  const reviews = [{
    quote: 'They pulled my Carfax report to verify what mileage-based maintenance was actually due. There were absolutely no high-pressure sales or unnecessary upsells — they only recommended what made sense. The prices are very reasonable. Despite having much better customer reviews than other local independent shops, they actually beat their estimates. The staff is incredibly kind and personable as well.',
    author: 'James K.'
  }, {
    quote: 'From start to finish, they were professional, honest, and a true pleasure to work with. They were right on time, kept us informed, and went above and beyond — even telling us we didn’t need a service we originally came in for, which saved us money. That kind of honesty is rare and so appreciated!',
    author: 'De B.'
  }, {
    quote: 'I dropped my car off on short notice due to Valvoline telling me I had a oil leak they got me in right away looked over things very thoroughly and assured me I did not have an oil leak... I really appreciate the honesty and great service I will definitely be coming back for any future auto repairs and recommending to all friends and family.',
    author: 'Kareem H.'
  }];
  return <section className="bg-white px-4 py-20" data-id="element-155" data-mp="2d0cfkdi21znp">
      <div className="mx-auto max-w-6xl" data-id="element-156" data-mp="2cz1beckp6pw2">
        <motion.img initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} src="https://cdn.magicpatterns.com/uploads/utu1Tmp4LyCtBUmwfRTH7Z/Team_Photo_Canva.jpg" alt="The Lancer Service team standing together in the shop" className="mb-16 h-auto w-full rounded-2xl border border-gray-200 object-contain shadow-2xl shadow-black/20" data-id="element-157" data-mp="2d25oy0k1yxze" />

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="mb-16 text-center" data-id="element-158" data-mp="1havhxqlisa5f">
          <span className="mb-4 block text-sm font-bold uppercase tracking-widest text-brand-accent" data-id="element-159" data-mp="1w6l6nwi3b1du">
            CUSTOMER REVIEWS
          </span>
          <h2 className="mb-6 font-heading text-3xl font-extrabold uppercase tracking-wide text-brand-dark md:text-4xl lg:text-5xl" data-id="element-160" data-mp="251raipxsv9dq">
            DON'T JUST TAKE OUR WORD FOR IT.
          </h2>
          <div className="flex items-center justify-center gap-3 text-xl font-bold text-brand-dark" data-id="element-161" data-mp="2ezymsvh5939e">
            <span data-id="element-162" data-mp="2jz1qocle13fs">4.9</span>
            <div className="flex text-brand-gold" data-id="element-163" data-mp="2jy8gf1n7zvsw">
              {[...Array(5)].map((_, index) => <StarIcon key={index} className="h-6 w-6 fill-current" data-id="element-164" data-mp="8by6uxh6w2me" data-mpi={index} />)}
            </div>
            <span className="text-[14px] font-medium text-gray-500" data-id="element-165" data-mp="3dn2315r4ib1">
              Based on 600+ Google reviews
            </span>
          </div>
          <a href="https://share.google/mOhoxsuWCYUR8CJFk" target="_blank" rel="noopener noreferrer" className="mt-6 inline-flex items-center gap-2 font-bold text-brand-accent transition-colors hover:text-brand-accentHover" data-id="element-166" data-mp="3pjjxtn0jon81">
            <StarIcon className="h-4 w-4 fill-current" data-id="element-167" data-mp="hb1qq3o6km1y" />
            Read our Google reviews
          </a>
        </motion.div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-3" data-id="element-168" data-mp="cb75afn6cooa">
          {reviews.map((review, index) => <motion.article key={review.author} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="flex flex-col rounded-2xl border border-gray-200 bg-brand-light p-8 shadow-sm" data-id="element-169" data-mp="19se3r72p8764" data-mpi={index}>
              <div className="mb-6 flex text-brand-gold" data-id="element-170" data-mp="189np6g526lce">
                {[...Array(5)].map((_, starIndex) => <StarIcon key={starIndex} className="h-5 w-5 fill-current" data-id="element-171" data-mp="1d8qix4fl9552" data-mpi={starIndex} />)}
              </div>
              <p className="mb-8 flex-grow text-lg italic leading-relaxed text-gray-700" data-id="element-172" data-mp="yijcxo6rpel9">
                “{review.quote}”
              </p>
              <div className="border-t border-gray-200 pt-4" data-id="element-173" data-mp="13gkv86wdd9vo">
                <p className="font-bold text-brand-dark" data-id="element-174" data-mp="1r7ggel6bl6ty">{review.author}</p>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}